<ng-container *ngIf="currentUserCanRuo$ | async">
  <a (click)="ruoModal.open()" class="cursor-pointer ruo-link one-link-no-style" i18n="@@for-research-use-only">For research use only</a>
  <app-ruo-popup></app-ruo-popup>
</ng-container>
